import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SwitchProspectDialog = ({ open, onKeepWorking, onSwitch }) => (
  <Dialog open={open} onClose={onKeepWorking} maxWidth='xs' fullWidth>
    <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
      Unsaved work
      <IconButton aria-label='Close' onClick={onKeepWorking} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography variant='body2' color='text.secondary'>
        You have work in this Engage session that will be discarded if you leave.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
      <Button variant='outlined' onClick={onKeepWorking} sx={{ textTransform: 'none', fontWeight: 600 }}>
        Keep working
      </Button>
      <Button variant='contained' onClick={onSwitch} sx={{ textTransform: 'none', fontWeight: 600 }}>
        Leave without saving
      </Button>
    </DialogActions>
  </Dialog>
);

export default SwitchProspectDialog;
